module.exports = __webpack_public_path__ + "static/media/add-member.692c6354.svg";